import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class WorkInProgress extends RestApiModel {
  static getResourceEndpoint() {
    return '/PolicyPending';
  }

  static firmOrderAction(policyPk, language) {
    return api.get('/FirmOrderAction', {
      params: { Policy_PK : policyPk, language }
    });
  }
}

export default WorkInProgress;
